import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let specialismSwiperWr = document.querySelectorAll('.specialism-swiper-wr');
const SPECIALISMS_ROTATE_BREAKPOINT = 1200;
const RESIZE_THROTTLE_DELAY = 150;

function throttle(callback, delay) {
  let isThrottled = false;
  let savedArgs = null;
  let savedContext = null;

  function throttled(...args) {
    if (isThrottled) {
      savedArgs = args;
      savedContext = this;
      return;
    }

    callback.apply(this, args);
    isThrottled = true;

    setTimeout(() => {
      isThrottled = false;

      if (savedArgs) {
        throttled.apply(savedContext, savedArgs);
        savedArgs = null;
        savedContext = null;
      }
    }, delay);
  }

  return throttled;
}

function setSpecialismPaletteClasses(slides) {
  slides.forEach((slide, index) => {
    slide.classList.remove(
        'specialism-card--palette-1',
        'specialism-card--palette-2',
        'specialism-card--palette-3'
    );

    slide.classList.add(`specialism-card--palette-${(index % 3) + 1}`);
  });
}

function updateSpecialismSlidesOrder(wrapper, slides) {
  if (!wrapper || slides.length < 2) return false;

  const [firstSlide, secondSlide] = slides;

  if (window.innerWidth <= SPECIALISMS_ROTATE_BREAKPOINT) {
    if (wrapper.firstElementChild !== secondSlide) {
      wrapper.insertBefore(secondSlide, firstSlide);
      return true;
    }

    return false;
  }

  if (wrapper.firstElementChild !== firstSlide) {
    wrapper.insertBefore(firstSlide, secondSlide);
    return true;
  }

  return false;
}

specialismSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    const shouldRotateSpecialisms = el.classList.contains('rotate-specialisms-list');
    const initialSlides = wrapper ? Array.from(wrapper.children) : [];

    if (shouldRotateSpecialisms) {
      setSpecialismPaletteClasses(initialSlides);
      updateSpecialismSlidesOrder(wrapper, initialSlides);
    }

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 18,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        375: {
          slidesPerView: 1,
          spaceBetween: 24,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 49,
        }
      },
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
    });
    swiperObserver(swiper);

    if (shouldRotateSpecialisms) {
      window.addEventListener('resize', throttle(() => {
        const isChanged = updateSpecialismSlidesOrder(wrapper, initialSlides);

        if (isChanged) {
          swiper.update();
        }
      }, RESIZE_THROTTLE_DELAY));
    }
  }
});

const specialismsCardContentsArr = document.querySelectorAll('.specialism-card__content');

if(specialismsCardContentsArr) {
  lineTitlesFunc(specialismsCardContentsArr)
}

const specialismsCardTextArr = document.querySelectorAll('.specialism-card__text');

if(specialismsCardTextArr) {
  lineTitlesFunc(specialismsCardTextArr)
}
